import { Icon } from '@chakra-ui/react';

export default function SFArchiveOutlined(props) {
  return (
    <Icon
      width={4}
      height='15px'
      viewBox='0 0 16 15'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path d='M3.71094 14.5625C2.17188 14.5625 1.35156 13.7734 1.35156 12.2344V4.45312C0.59375 4.32812 0.1875 3.75781 0.1875 2.92188V1.73438C0.1875 0.78125 0.757812 0.179688 1.67188 0.179688H14.3203C15.2812 0.179688 15.8047 0.78125 15.8047 1.73438V2.92188C15.8047 3.75781 15.3984 4.32812 14.6406 4.45312V12.2344C14.6406 13.7656 13.8203 14.5625 12.2812 14.5625H3.71094ZM1.99219 3.29688H14.0078C14.3984 3.29688 14.5469 3.13281 14.5469 2.74219V1.91406C14.5469 1.52344 14.3984 1.35938 14.0078 1.35938H1.99219C1.60156 1.35938 1.44531 1.52344 1.44531 1.91406V2.74219C1.44531 3.13281 1.60156 3.29688 1.99219 3.29688ZM3.69531 13.3828H12.2969C12.9922 13.3828 13.3828 13 13.3828 12.2969V4.47656H2.60938V12.2969C2.60938 13 2.99219 13.3828 3.69531 13.3828ZM5.42188 7.625C5.09375 7.625 4.86719 7.39844 4.86719 7.05469V6.80469C4.86719 6.46094 5.09375 6.24219 5.42188 6.24219H10.5781C10.9062 6.24219 11.1406 6.46094 11.1406 6.80469V7.05469C11.1406 7.39844 10.9062 7.625 10.5781 7.625H5.42188Z' />
    </Icon>
  );
}
